import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-24 bg-[#1A3A6B] relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#1E88E5]/20 rounded-full translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
          {/* Left */}
          <div className="max-w-xl">
            <span className="text-[#60AEFF] font-heading font-semibold text-sm uppercase tracking-widest block mb-3">
              Ready to Get Started?
            </span>
            <h2
              className="font-heading font-800 text-white leading-tight mb-4"
              style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.75rem)", fontWeight: 800 }}
            >
              Get Your Free Quotation Today
            </h2>
            <p className="text-blue-200 font-body text-base leading-relaxed">
              Ready to book your gutter clearance in <strong className="text-white">Northfleet, Gravesend and Kent</strong>? Get a fast, no-obligation quote — we respond within 24 hours.
            </p>
          </div>

          {/* Right */}
          <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-4 lg:flex-shrink-0">
            <a
              href="#contact-us"
              className="flex items-center justify-center gap-2 bg-[#1E88E5] hover:bg-[#1565C0] text-white font-heading font-semibold text-base px-8 py-4 rounded-lg transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line"></i>
              Get a Free Quote
            </a>
            <a
              href="tel:02084322244"
              className="flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 border border-white/30 text-white font-heading font-semibold text-base px-8 py-4 rounded-lg transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-[#60AEFF]"></i>
              Call Now
            </a>
          </div>
        </div>

        {/* Trust strip */}
        <div className="mt-14 pt-10 border-t border-white/15 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: "ri-shield-check-fill", label: "Fully Insured" },
            { icon: "ri-award-fill", label: "10+ Years Experience" },
            { icon: "ri-calendar-check-fill", label: "Flexible Scheduling" },
            { icon: "ri-thumb-up-fill", label: "Satisfaction Guaranteed" },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl flex-shrink-0">
                <i className={`${item.icon} text-[#60AEFF] text-lg`}></i>
              </div>
              <span className="font-body font-medium text-sm text-blue-100">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
